import { render, staticRenderFns } from "./Deslocation.vue?vue&type=template&id=3a1ec154&scoped=true&"
import script from "./Deslocation.vue?vue&type=script&lang=js&"
export * from "./Deslocation.vue?vue&type=script&lang=js&"
import style0 from "./Deslocation.vue?vue&type=style&index=0&id=3a1ec154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ec154",
  null
  
)

export default component.exports